import React from 'react'

const Inventory = ({
  hsn,
  setHsn,
  weight,
  setWeight,
  length,
  setLength,
  breadth,
  setBreadth,
  height,
  setHeight,
}) => {
  return (
    <div className='card mb-3'>
      <div className='card-header'><label className='form-label'>Shipping & Dimensions</label></div>
      <div className='card-body'>
        <div className='row'>
          <div className='col-6'>
            <div className='mb-3'>
              <label htmlFor='hsn' className='form-label'>
                HSN Code
              </label>
              <input
                type='text'
                onChange={(e) => setHsn(e.target.value)}
                name='hsn'
                className='form-control'
                id='hsn'
                placeholder=''
                defaultValue={hsn}
              />
            </div>
          </div>
          <div className='col-6'>
            <div className='mb-3'>
              <label htmlFor='weight' className='form-label'>
                Weight (kg)
              </label>
              <input
                type='number'
                step='0.01'
                onChange={(e) => setWeight(e.target.value)}
                name='weight'
                className='form-control'
                id='weight'
                placeholder=''
                defaultValue={weight}
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-4'>
            <div className='mb-3'>
              <label htmlFor='length' className='form-label'>
                Length (cm)
              </label>
              <input
                type='number'
                step='0.1'
                onChange={(e) => setLength(e.target.value)}
                name='length'
                className='form-control'
                id='length'
                placeholder=''
                defaultValue={length}
              />
            </div>
          </div>
          <div className='col-4'>
            <div className='mb-3'>
              <label htmlFor='breadth' className='form-label'>
                Breadth (cm)
              </label>
              <input
                type='number'
                step='0.1'
                onChange={(e) => setBreadth(e.target.value)}
                name='breadth'
                className='form-control'
                id='breadth'
                placeholder=''
                defaultValue={breadth}
              />
            </div>
          </div>
          <div className='col-4'>
            <div className='mb-3'>
              <label htmlFor='height' className='form-label'>
                Height (cm)
              </label>
              <input
                type='number'
                step='0.1'
                onChange={(e) => setHeight(e.target.value)}
                name='height'
                className='form-control'
                id='height'
                placeholder=''
                defaultValue={height}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Inventory
